import React from "react";
import styled from "styled-components";
import { TaskType } from "@coworker/apprestructured/src/tasks/enums/taskTypes";
import ScannerErrorComponent from "../../components/error-component/ScannerErrorComponent";
import ScannerBottomButtonBar from "../../components/redirect-button-component/ScannerBottomButtonBar";
import SearchBarComponent from "../../components/search-component/SearchBarComponent";
import { BarcodeIcon } from "../../components/scanner-ui-component/BarcodeIcon";

const PageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: 0.5rem;
`;

const BottomBarContainer = styled.div`
  position: absolute;
  max-width: 1000px;
  bottom: 1rem;
  width: 100%;
  z-index: 3;
`;

interface ScannerPageProps {
  error: string | null;
  setError: (err: string | null) => void;
  taskType: TaskType;
  readyToScanText: string;
  pushSearch: () => void;
  onCloseClick?: () => void;
  scannerType: "honeywell" | "hdi";
}

const HoneywellScannerPagePresentation: React.FC<ScannerPageProps> = ({
  error,
  setError,
  taskType,
  readyToScanText,
  pushSearch,
  onCloseClick,
  scannerType,
}) => {
  return (
    <PageContainer>
      <ScannerErrorComponent error={error} setError={setError} />
      <SearchBarComponent
        onSearchBarClick={pushSearch}
        shouldShowCloseButton={false}
        onCloseSearchClick={onCloseClick ?? (() => {})}
      />
      <BarcodeIcon
        readyToScanString={readyToScanText}
        scannerType={scannerType}
      />
      <BottomBarContainer>
        <ScannerBottomButtonBar typeOfScanner="honeywell" taskType={taskType} />
      </BottomBarContainer>
    </PageContainer>
  );
};

export default HoneywellScannerPagePresentation;
